import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets/themeFour/f3.png'


const _hoisted_1 = { class: "panel_container" }
const _hoisted_2 = { class: "dialogBox tooltip" }
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  span: "14",
  class: "textSet"
}
const _hoisted_5 = { class: "applicationText" }
const _hoisted_6 = { class: "download_btn" }
const _hoisted_7 = ["src"]
const _hoisted_8 = {
  span: "14",
  class: "textSet"
}
const _hoisted_9 = { class: "applicationText" }

import { goToLink } from '@/view/home/supportScript';
import { onMounted, ref } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'downloadPanel',
  props: {
    itemData: {}
  },
  setup(__props: any) {

const iosData = ref({
    url: "",
    redirect_url: "",
    display: false,
    text: "",
})
const androidData = ref({
    url: "",
    redirect_url: "",
    display: false,
    text: "",
})
const customStyle = ref({
    color: ""
})
const props = __props

onMounted(() => {
    iosData.value.url = props.itemData.ios.url
    iosData.value.display = props.itemData.ios.display
    iosData.value.redirect_url = props.itemData.ios.redirect_url
    iosData.value.text = props.itemData.ios.text

    androidData.value.url = props.itemData.android.url
    androidData.value.display = props.itemData.android.display
    androidData.value.redirect_url = props.itemData.android.redirect_url
    androidData.value.text = props.itemData.android.text

    customStyle.value.color = props.itemData.styles.color
})


return (_ctx: any,_cache: any) => {
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[3] || (_cache[3] = _createElementVNode("img", {
      src: _imports_0,
      alt: "",
      width: "55%"
    }, null, -1)),
    _createVNode(_component_van_row, { class: "btn_section" }, {
      default: _withCtx(() => [
        _createVNode(_component_van_col, {
          span: "24",
          class: "btnGroup"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('home.downloadDialog')), 1),
            (iosData.value.display)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "download_item",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(goToLink)(iosData.value.redirect_url)))
                }, [
                  _createElementVNode("img", {
                    src: iosData.value.url,
                    alt: "",
                    width: "25%"
                  }, null, 8, _hoisted_3),
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('home.application')), 1),
                    _createElementVNode("div", _hoisted_6, _toDisplayString(iosData.value.text), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            (androidData.value.display)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  span: "11",
                  class: "download_item",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(goToLink)(androidData.value.redirect_url)))
                }, [
                  _createElementVNode("img", {
                    src: androidData.value.url,
                    alt: "",
                    width: "25%"
                  }, null, 8, _hoisted_7),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('home.application')), 1),
                    _createElementVNode("div", {
                      class: "download_btn",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(goToLink)(androidData.value.redirect_url)))
                    }, _toDisplayString(androidData.value.text), 1)
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})